<template>
    <div class="column">
        <div class="card tilebox-one">
            <div class="card-body">
                <i class="dripicons-basket float-end text-muted"></i>
                <h6 class="text-muted text-uppercase mt-0">Timelog Com.</h6>
                <h2 class="m-b-20"><animated-number :value="+timelogPercent" />%</h2>
                <span class="badge" :class="{'bg-primary' : previousTimelogPercent > 0, 'bg-alert' : previousTimelogPercent <= 0}"> <animated-number :value="+previousTimelogPercent" />% </span> <span class="text-muted">From previous</span>
            </div>
        </div>
    </div>
</template>
<script>
    import AnimatedNumber from '../../../../components/AnimatedNumber.vue'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        components: {
            AnimatedNumber
        },
        props: {
            params: null,
            paramsPrevious: null,
            user: {},
            value: null
        },
        data() {
            return {
                timelogData: {
                    current: {},
                    previous: {}
                },
                monthly_hours: 140,
                syncTimeout: null
            }
        },
        mounted() {
            this.fillData();
        },
        watch: {
            'params'(value) {
                this.fillData()
            },
            'paramsPrevious' (value) {
                this.fillData()
            },
            'timelogData.current' (value) {
                this.$emit('input', this.timelogObject)
            },
            'timelogData.previous' (value) {
                this.$emit('input', this.timelogObject)
            },
        },
        methods: {
            ...mapActions(['getUserTimelogs']),
            fillData() {
                if (this.syncTimeout) {
                    clearTimeout(this.syncTimeout)
                }

                this.syncTimeout = setTimeout(() => {
                    this.getUserTimelogs(this.params).then(p => this.timelogData.current = p.data.data)
                    this.getUserTimelogs(this.paramsPrevious).then(p => this.timelogData.previous = p.data.data)
                }, 250)
            },
            calcPercent(a, b) {
                return Math.round((a / b) * 1000) /10
            }
        },
        computed: {
            timelogObject() {
                return { timelogData: this.timelogData, timelogPercent: this.timelogPercent, previousTimelogPercent: this.previousTimelogPercent }
            },
            timelogPercent() {
                return this.calcPercent(+this.currentTime, this.monthly_hours) || 0
            },
          /*
           *Se hizo una pequeña mejora porque devolvia NaN asi que resolvimos eso con el isFinite */
            previousTimelogPercent() {
              let pt = isFinite(+this.previousTime) ? +this.previousTime : 0
              let ct = isFinite(+this.currentTime) ? +this.currentTime : 0
              let diff = ct - pt
              let curr = this.calcPercent(diff, ct)
              curr = isFinite(curr) ? curr :  0
                return curr ? curr : pt > 0 ? -100 :  0
            },

            currentTime() {
                return (this.timelogData.current.length > 0 ? this.timelogData.current.map(p => p.time).reduce((a, b) => a + b) : 0) || 0
            },
            previousTime() {
                return (this.timelogData.previous.length > 0 ? this.timelogData.previous.map(p => p.time).reduce((a, b) => a + b) : 0) || 0
            }
        }
    }
</script>